let clientemail = document.getElementById('RegisterForm-email');
let clientpassword = document.getElementById('RegisterForm-password');
let clientlogin = document.getElementById('CustomerEmail');
let custpassword = document.getElementById('CustomerPassword');
let recoveremail = document.getElementById('RecoverEmail');
clientemail != null ? clientemail.addEventListener('input', notblankregister) : null;
clientpassword != null ? clientpassword.addEventListener('input', notblankregister) : null;
clientlogin != null ? clientlogin.addEventListener('input', notblanklogin) : null;
custpassword != null ? custpassword.addEventListener('input', notblanklogin) : null;
recoveremail != null ? recoveremail.addEventListener('input', recover) : null;
function notblankregister() {
  if(clientpassword.value.length > 0 && clientemail.value.length > 0){
    document.getElementById('checkjs-register').classList.add('active');
    document.getElementById('checkjs-register').removeAttribute('disabled');
  }
  else{
    document.getElementById('checkjs-register').classList.remove('active');
    document.getElementById('checkjs-register').setAttribute('disabled','true');
  }
}
function notblanklogin() {
  if(clientlogin.value.length > 0 && custpassword.value.length > 0){
    document.getElementById('checkjs-signin').classList.add('active');
    document.getElementById('checkjs-signin').removeAttribute('disabled');
  }
  else{
    document.getElementById('checkjs-signin').classList.remove('active');
    document.getElementById('checkjs-signin').setAttribute('disabled','true');
  }
}

function recover() {
  if(recoveremail.value.length > 0){
    document.getElementById('checkjs-recover').classList.add('active');
    document.getElementById('checkjs-recover').removeAttribute('disabled');
  }
  else{
    document.getElementById('checkjs-recover').classList.remove('active');
    document.getElementById('checkjs-recover').setAttribute('disabled','true');
  }
}
